import { render, staticRenderFns } from "./template.html?vue&type=template&id=7cb36a50&scoped=true&"
import script from "./SidenaviSearchToday.vue?vue&type=script&lang=ts&"
export * from "./SidenaviSearchToday.vue?vue&type=script&lang=ts&"
import style0 from "./SidenaviSearchToday.vue?vue&type=style&index=0&id=7cb36a50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb36a50",
  null
  
)

export default component.exports